import { render, staticRenderFns } from "./TaksDetailsContent.vue?vue&type=template&id=96557ba0"
import script from "./TaksDetailsContent.vue?vue&type=script&lang=js"
export * from "./TaksDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports